<div class="overlay-spinner-container">      
    <div class="overlay-spinner"></div>
</div>